const headerConfig = {
  name: "Selmeci Kocka Jusko",
  people: ["Alex Selmeci", "Tomáš Kocka Jusko"],
  address: {
    street: "Černokostelecká 1168/90",
    city: "Prague 100 00",
    country: "CZE"
  },
  contacts: [
    { label: "email", value: "studio@selmecikockajusko.com" },
    { label: "web", value: "www.selmecikockajusko.com" },
    { label: "instagram", value: "@selmecikockajusko" }
  ],
  shortName: "SKJ",
  cvLabel: "REGISTER"
};

export default headerConfig;
